<script>
  //import appConfig from "@/app.config";
  //import axios from 'axios';
  
  // 초기세팅
  function initialState() {
    return {
      token: "",
      login: {
        idx: 0,
        level: 0,
        nick: "",
        isLogin: false,
      },
    };
  }
  
  export default {
    components: {
    },
    data() {
      return initialState();
    },
    props: {
      selectedMenu: {
        type: String,
      },
    },
    computed: {
    },
    mounted() {
    },
    created() {
      this.first()
    },
    methods: {
      first() {
        let getLocalStorage = JSON.parse(localStorage.getItem('user'))
        if (getLocalStorage) {
          this.login.idx = getLocalStorage.idx
          this.login.nick = getLocalStorage.nick
          this.login.level = getLocalStorage.level
          this.token = getLocalStorage.token
  
          // 레벨 98 이하거나 로그인 안한상태면 첫화면으로
          if (this.login.level < 98) {
            this.$notify({ type: 'error', duration: 2000, title: '실패', text: '관리자 권한이 없습니다.' })
            this.$router.push('/');
          } else {
            //this.readHistory()
          }
        } else {
          this.$notify({ type: 'error', duration: 2000, title: '실패', text: '관리자 권한이 없습니다.' })
          this.$router.push('/');
        }
      },
    },
  }
  </script>
  
  <template>
    <div class="rounded shadow">
      <div class="p-4 border-bottom">
        <h5 class="text-md-left text-center">메일전송</h5>
        <div>
          <div class="row mt-4">
            <div class="col-md-6">
              <div class="form-group">
                <label for="memberNick" class="text-secondary admin-label">곧 만들 예정</label>
                <div class="position-relative">
                  <input
                    name="memberNick"
                    id="memberNick"
                    type="text"
                    class="form-control pl-5 text-bold text-dark"
                    placeholder=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>